<template>
	<div class="index">
		<banner></banner>
		<productionShow></productionShow>
	</div>
</template>

<script>
	import banner from '../components/banner.vue'
	import productionShow from '../components/productionShow.vue'

	export default {
		name: 'Index',
		components: {
			banner,
			productionShow
		}
	}
</script>

<style>
</style>
